<script setup>
  import { useRoute } from 'vue-router';

  import CredereHeader from '@/components/Credere/Header.vue';

  const route = useRoute();
</script>

<template>
  <credere-header
    :title="route.query.title || route.meta.title"
    :subtitle="route.query.subtitle || route.meta.subtitle"
  />
</template>

<style lang="scss">
</style>
